const getDefaultState = () => {
    return {
        gid: '',
        offer: {
            range: [],
            year: '',
            make: '',
            model: '',
            style: '',
            mileage: '',
        },

        carDetails: {},

        form: {
            /* Find Vehicles */
            vehicle_vin: null,
            plate_state: null,
            plate_number: null,
            vehicle_year: null,
            vehicle_make: null,
            vehicle_model: null,
            vehicle_style: null,
            vehicle_source_id: null,

            /* Vehicle Basics */
            vehicle_mileage: null,
            color: null,
            vacs: null,
            is_original_owner: null,
            is_liened: null,
            liened_type: null,
            owed_amount: null,
            lease_monthly_payment: null,
            lease_number_payments: null,
            lease_amount_remaining: null,

            /* Vehicle Condition */
            // Accident
            insurance_payout_amount: null,
            has_frame_damage: null,
            carfax_has_bad_vhr: null,

            // External Damage
            has_external_damage: null,
            external_damage_amount: null,

            // Tire
            front_tire_age: null,
            rear_tire_age: null,

            // Mechanical Issues
            has_mechanical_issues: null,
            has_mechanical_ac: null,
            has_mechanical_brakes: null,
            has_mechanical_catalytic_converter: null,
            has_mechanical_engine: null,
            has_mechanical_exhaust: null,
            has_mechanical_head_gasket: null,
            has_mechanical_oil_leak: null,
            has_mechanical_sunroof_moonroof: null,
            has_mechanical_suspension: null,
            has_mechanical_transmission: null,
            has_mechanical_other: null,
            mechanical_other_note: null,

            // Illuminated Warning Lights
            has_warning_lights: null,
            has_warning_lights_abs: null,
            has_warning_lights_srs: null,
            has_warning_lights_battery: null,
            has_warning_lights_brake: null,
            has_warning_lights_engine: null,
            has_warning_lights_tpms: null,
            has_warning_lights_suspension_fault: null,
            has_warning_lights_traction_control: null,

            // Aftermarket Modifications
            has_modifications: null,
            has_modifications_exhaust: null,
            has_modifications_performance: null,
            has_modifications_stereo: null,
            has_modifications_spoiler: null,
            has_modifications_sunroof_moonroof: null,
            has_modifications_suspension_lowered: null,
            has_modifications_wheel: null,
            has_aftermarket_tint: null,

            // Odor
            has_odor: null,

            // Other Issues
            is_salvage_title: null,
            is_rebuilt_title: null,
            has_fire_damage: null,
            has_flood_damage: null,
            was_stolen: null,
            other_issues_repair_cost: null,

            /* Consumer Data */
            consumer: {
                first_name: null,
                last_name: null,
                postal_code: null,
                cell_phone: null,
                email: null,
                best_time_to_contact: null,
            },

            /* Other Vehicle Data */
            new_vehicle_type: null,
            new_vehicle_year: null,
            new_vehicle_make: null,
            new_vehicle_model: null,
            new_vehicle_source_id: null,
            expect_transact_months: null,
            vehicle_base_price: null,
            vehicle_market_price: null,
            vehicle_trade_price: null,

            /* Other Internal Data */
            arkona: null,
        },

        helperData: {
            has_accident: null,
            has_other_issues: null,
            mechanical_issues_valid: null,
            warning_lights_valid: null,
            modifications_valid: null,
            other_issues_valid: null,
        },
    };
};

export const state = () => getDefaultState();

export const mutations = {
    SET_GID(state, gid) {
        state.gid = gid;
    },

    SET_CAR_DETAILS(state, details) {
        state.carDetails = details;
    },

    SET_FORM_VALUE(state, { key, value }) {
        state.form[key] = value;
    },

    SET_FORM_VALUE_NUMBER(state, { key, value }) {
        if (value) state.form[key] = parseInt(value);
        else state.form[key] = null;
    },

    SET_FORM_VAC_VALUE(state, { index, selected }) {
        state.form.vacs[index].selected = selected;
    },

    SET_FORM_CONSUMER_VALUE(state, { key, value }) {
        state.form.consumer[key] = value;
    },

    SET_FORM_CONSUMER_VALUE_NUMBER(state, { key, value }) {
        if (value) state.form.consumer[key] = parseInt(value);
        else state.form.consumer[key] = null;
    },

    SET_HELPER_VALUE(state, { key, value }) {
        state.helperData[key] = value;
    },

    SET_OFFER(state, offer) {
        state.offer = offer;
    },

    RESET_STATE(state) {
        Object.assign(state, getDefaultState());
    },
};
